<template>
  <SubHeader
    title="Créer Caracterisation"
    :breads="[
      { name: 'Caracterisations' },
      { name: 'Créer une caracterisation' },
    ]"
    :action="{}"
  />
  <div class="row">
    <div class="col-md-12">
      <form @submit.prevent="handleSubmit(this.data)">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header card-header-content-md-between">
                <h3 class="card-header-title">Caracterisation</h3>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <label class="form-label" for="label">Libellé</label>
                  <input
                    type="text"
                    v-model="data.name"
                    id="label"
                    class="form-control"
                    placeholder="Nom de la caracterisation"
                    value=""
                  />
                </div>

                <div class="mb-3">
                  <label class="form-label" for="description"
                    >Description
                  </label>
                  <textarea
                    type="number"
                    min="1"
                    v-model="data.description"
                    id="description"
                    class="form-control"
                    placeholder="Description de la caractérisation"
                  >
                  </textarea>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="coefficient"
                    >Coefficient</label
                  >
                  <input
                    type="number"
                    min="1"
                    v-model="data.coefficient"
                    id="coefficient"
                    class="form-control"
                    placeholder="Coefficient de la caractérisation"
                    value=""
                  />
                </div>

                <div class="mb-3">
                  <label class="form-label" for="type">Type de champ</label>
                  <select
                    name=""
                    v-model="data.type"
                    class="form-select"
                    id=""
                    placeholder="Le type de champ de la caracterations"
                  >
                    <option
                      :value="val"
                      v-for="(val, index) in elementsSelected"
                      :key="index"
                    >
                      {{ val }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="filled_by_human"
                    >Le champ sera remplir par
                  </label>
                  <select
                    name=""
                    v-model="data.filled_by_human"
                    class="form-select"
                    id="filled_by_human"
                  >
                    <option
                      :value="val.value"
                      v-for="(val, index) in settedBy"
                      :key="index"
                    >
                      {{ val.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header card-header-content-md-between">
                    <h3 class="card-header-title">Valeurs</h3>
                  </div>
                  <div class="card-body">
                    <div
                      class="row mb-1"
                      v-for="(value_data, i) in data.elements"
                      :key="i"
                    >
                      <div class="col-lg-6">
                        <div class="mb-1">
                          <label class="form-label" for="value_data_name"
                            >Valeur</label
                          >
                          <input
                            type="text"
                            v-model="value_data.name"
                            required
                            id="value_data_name"
                            class="form-control"
                            placeholder="Valeur possible"
                          />
                        </div>
                      </div>
                      <div class="col-lg-5">
                        <div class="mb-1">
                          <label class="form-label" for="value_data_weight"
                            >Poids</label
                          >
                          <input
                            type="number"
                            min="1"
                            v-model="value_data.weight"
                            required
                            id="value_data_weight"
                            class="form-control"
                            placeholder="Poid du valeur"
                            value=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-1">
                        <div class="mb-1">
                          <label class="form-label" for="value_data_weight"
                            >&nbsp;</label
                          >
                          <button
                            class="btn btn-danger"
                            @click.prevent="setElements(i)"
                            v-if="i != 0"
                          >
                            <i class="bi-x-lg"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-lg-12 text-center">
                        <u
                          class="text-primary cursor-pointer d-flex"
                          style="cursor: pointer"
                          @click="setElements(0, true)"
                        >
                          <i class="bi-plus-circle-fill me-1"></i>
                          <span>Ajouter une nouvelle valeur</span>
                        </u>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <button type="submit" class="btn btn-primary">
                  Enregistrer</button
                >&nbsp;
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="this.$router.back()"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "AdminConfigCreateCaracterisation",
  components: {
    SubHeader,
  },
  data() {
    return {
      data: {
        elements: [
          {
            name: null,
            weight: 1,
          },
        ],
        name: null,
        description: null,
        coefficient: 1,
        type: "Choix simple",
        filled_by_human: false,
      },
      elementsSelected: ["Choix simple", "Choix multiple", "Zone de texte"],
      settedBy: [
        { value: true, label: "Agent" },
        { value: false, label: "IA" },
      ],
    };
  },

  computed: {
    ...mapFields("caracterisation/create", {
      isLoading: "isLoading",
      isSuccess: "isSuccess",
      showMessage: "showMessage",
      message: "message",
      items: "items",
      isCreated: "isCreated",
    }),
  },

  methods: {
    ...mapActions({
      handleSubmit: "caracterisation/create/create",
      reset: "caracterisation/create/resetData",
    }),
    setElements(i, add = false) {
      if (add) {
        this.data.elements.push({ name: null, weight: 1 });
      } else {
        this.data.elements = this.data.elements.filter(
          (val, index) => index !== i
        );
      }
    },
  },
  watch: {
    isCreated(val) {
      if (val) {
        this.$router.push({ name: "AdminConfigCaracterisation" });
      }
    },
  },

  unmounted() {
    this.reset();
  },
  mounted() {},
};
</script>
